import type { ResourceNamesStandard } from "@Common/types/resources";
import type { WrappedComponent } from "@Src/layout/Wrapper";
import analyticsPublic from "@Src/resources/analytics_public";
import applications from "@Src/resources/applications";
import applicationsPublic from "@Src/resources/applications_public";
import forms from "@Src/resources/forms";
import formsPublic from "@Src/resources/forms_public";
import settings from "@Src/resources/settings";
import stripeEvents from "@Src/resources/stripe_events";
import support from "@Src/resources/support";
import type { SvgIconTypeMap } from "@mui/material";
import type { OverridableComponent } from "@mui/material/OverridableComponent";

export interface Resource {
	list?: WrappedComponent;
	show?: WrappedComponent;
	create?: WrappedComponent;
	edit?: WrappedComponent;
	icon?: OverridableComponent<SvgIconTypeMap> & {
		muiName: string;
	};
	name: ResourceNamesStandard;
	apiPath: string;
	path: string;
	options?: { label: string };
}

export const resourcesStandard: {
	[key in ResourceNamesStandard]: {
		resource: Resource;
	};
} = {
	analytics_public: { resource: analyticsPublic },
	applications: { resource: applications },
	applications_public: { resource: applicationsPublic },
	forms: { resource: forms },
	forms_public: { resource: formsPublic },
	settings: { resource: settings },
	stripe_events: { resource: stripeEvents },
	support: { resource: support },
};
